<template>
  <div class="content hp_space_between">
    <div class="left">
      <div>
        <div class="hp_cz_center_s new_tab">
          <div class="left hp_cz_center">
            <div :class="{ active: !tabIndex }" @click="changeTab(0)">动态资讯</div>
            <div :class="{ active: tabIndex }" @click="changeTab(1)">健康宣教</div>
          </div>
        </div>
        <div class="filtrate">
          <div>
            <a-radio-group
              v-if="!tabIndex"
              v-model="form.columnId"
              @change="radioChange"
              button-style="solid"
            >
              <a-radio-button value>全部文章</a-radio-button>
              <a-radio-button
                v-for="(item, index) in columns"
                :key="index"
                :value="item.id"
              >{{ item.name }}</a-radio-button>
            </a-radio-group>
          </div>
          <div>
            <a-checkbox @change="handleChange">最新</a-checkbox>
            <!-- <a-select
              v-model="form.sortName"
              style="width: 120px"
              @change="handleChange"
            >
              <a-select-option value="1">最新</a-select-option>
              <a-select-option value="2">最热</a-select-option>
            </a-select>-->
          </div>
        </div>
        <newsDemo :obj="item" v-for="(item, index) in list" :key="index"></newsDemo>
        <div>
          <a-pagination
            show-quick-jumper
            :current="currPage"
            :total="totalCount"
            :defaultPageSize="form.pageSize"
            @change="onChange"
          />
        </div>
      </div>
    </div>
    <advertising></advertising>
  </div>
</template>
<script>
import advertising from "@/components/Advertising";
import newsDemo from "./components/newsDemo";
import { getArticle } from "@/api/index";
import { getColumnInfo } from "@/api/news";
export default {
  components: {
    newsDemo,
    advertising,
  },
  data() {
    return {
      moreActive: false,
      tabIndex: 0,
      form: {
        pageNum: 1,
        pageSize: 6,
        columnType: 1,
        columnId: "",
        sortName: "2",
      },
      list: [],
      currPage: 1,
      totalCount: 1,
      columns: [],
    };
  },
  mounted() {
    this.init();
    this.initColumn();
  },
  methods: {
    handleChange(checkedValues) {
      checkedValues.target.checked
        ? (this.form.sortName = "1")
        : (this.form.sortName = "2");
      this.form.pageNum = 1;
      this.init();
    },
    async initColumn() {
      var res = await getColumnInfo(1);
      console.log("res==", res);
      this.columns = res.data;
    },
    changeTab(index) {
      this.tabIndex = index;
      this.currPage = 1;
      this.form.pageNum = 1;
      this.form.columnId = "";
      this.form.columnType = index + 1;
      this.init();
    },
    async init() {
      var res = await getArticle(this.form);
      this.list = res.data.list || [];
      this.totalCount = res.data.totalCount;
      this.currPage = res.data.currPage;
      console.log("res.data===", res.data);
    },
    onChange(pageNumber) {
      console.log("Page: ", pageNumber);
      this.form.pageNum = pageNumber;
      this.init();
    },
    radioChange(e) {
      this.form.pageNum = 1;
      this.init();
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  .left {
    .filtrate {
      border-radius: 10px;
      overflow: hidden;
      padding-left: 16px;
      padding-right: 25px;
      padding-top: 32px;
      padding-bottom: 32px;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ant-radio-group {
        font-size: 16px;
        .ant-radio-button-wrapper {
          margin-right: 40px;
          background: #fff;
          color: #999999;
          border: none;
          border-radius: 0;
          outline: none;
          box-shadow: none;
          padding: 0;
        }
        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          color: #1890ff;
          border-bottom: 2px solid #1890ff;
          font-weight: bold;
        }
      }
      .ant-checkbox-wrapper {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        /deep/ .ant-checkbox-inner {
          // width: 22px;
          // height: 22px;
          border-radius: 50%;
          // &::after {
          //   width: 8px;
          //   height: 16px;
          // }
        }
      }
    }
    .new_tab {
      .left {
        margin: auto;
        div {
          padding: 2px 32px;
          font-size: 18px;
          color: #686868;
          line-height: 36px;
          background: #f9f9f9;
          cursor: pointer;
        }
        .active {
          background: #0079fe;
          color: #fff !important;
          position: relative;
        }
      }
      .more {
        cursor: pointer;
        color: #686868;
      }
    }
  }
}
</style>
